import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { CircleQuestionMark } from "lucide-react";
import { Trans, useTranslation } from "react-i18next";

export function RuleHintDialog() {
  const { t } = useTranslation(["ram", "common"]);

  return (
    <Dialog>
      <DialogTrigger asChild>
        <button
          type="button"
          className="text-muted-foreground hover:text-foreground hover:border-border ml-4 inline-flex cursor-pointer items-center gap-2 rounded-md border border-transparent px-2 py-1 text-sm"
          aria-label={t("common:Hint")}
        >
          <CircleQuestionMark className="h-5 w-5" />
        </button>
      </DialogTrigger>

      <DialogContent className="max-w-lg">
        <div className="relative">
          <DialogHeader>
            <div className="flex items-start gap-3">
              <div className="flex h-8 w-8 items-center justify-center rounded-md">
                <CircleQuestionMark className="text-primary h-5 w-5" />
              </div>
              <div>
                <DialogTitle className="text-base font-semibold">{t("common:Hint")}</DialogTitle>
              </div>
            </div>
          </DialogHeader>
          <p className="text-muted-foreground mt-1 text-sm whitespace-pre-line">
            <Trans t={t} i18nKey="ram:PermissionsExplanation" components={{ strong: <strong /> }} />
          </p>
          <div className="mt-4">
            <div className="border-primary/10 bg-primary/5 rounded-md border p-4 text-sm">
              <div className="text-primary mb-2 font-semibold">{t("common:Tip")}</div>
              <ul className="text-muted-foreground list-disc space-y-2 pl-5">
                <li>
                  <Trans t={t} i18nKey="ram:PermissionsExplanationHintIntro" components={{ strong: <strong /> }} />
                </li>
                <li>
                  <Trans t={t} i18nKey="ram:PermissionsExplanationHintRule1" components={{ strong: <strong /> }} />
                </li>
                <li>
                  <Trans t={t} i18nKey="ram:PermissionsExplanationHintRule2" components={{ strong: <strong /> }} />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
